import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class AccountsTypeahead {

  constructor(el) {this.el = el;}

  initializeBloodhound() {

    let apiUrl = $(this.el).attr('data-api-url');
    const bloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: apiUrl + '?query=%QUERY',
        wildcard: "%QUERY"
      }});

    bloodhound.initialize();
    return bloodhound;

  }

  render(bloodhound, autocomplete = 'off') {

    let emptyTemplate = '<div class="empty-message">Unable to find that</div>';

    let accountTemplate = (name) => 
      '<div>' + name + '</div>';

    $(this.el).typeahead({
      hint: true,
      highlight: true,
      minLength: 0
    }, {
      name: 'typeahead',
      display: 'name',
      limit: 104,
      source: bloodhound.ttAdapter(),
      templates: {
        empty: emptyTemplate,
        suggestion(el) {
          return accountTemplate(el.name);
        }
      }
    });
  }

  setUp() {

    // Auto-focus typeahead
    $('#accountsFilterDropdown').on('shown.bs.dropdown', function () {
      $('#accounts_typeahead').focus();
    })    

    $('#accounts_typeahead').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) { 
      let url = $(this).attr('data-url');
      let params = {}
      let portfolioType = $(this).attr('data-portfolio-type');
      let reportType = $(this).attr('data-report-type');
      let clientId = $(this).attr('data-client-id');
      let userId = $(this).attr('data-user-id');
      let filt = suggestion.value;
      if (typeof portfolioType !== 'undefined') {params['portfolio_type'] = portfolioType};
      if (typeof reportType !== 'undefined') {params['report_type'] = reportType};
      if (typeof clientId !== 'undefined') {params['client_id'] = clientId};
      if (typeof userId !== 'undefined') {params['user_id'] = userId};
      params['account_id'] = filt;
      Turbo.visit(url + '?' + $.param(params));
    })
  }

}
